// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6); 
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999; 
    overflow: hidden; 
}

/* Estilo para la ventana flotante */
.floating-window {
    background: #fff;
    padding: 20px; 
    border-radius: 8px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
    width: 50%; 
    max-height: 80vh; 
    overflow-y: auto; 
    display: flex;
    flex-direction: column; 
    z-index: 1000;
}

/* Encabezado de la tabla */
.floating-window h3 {
    text-align: center;
    margin-bottom: 15px;
    font-size: 1.2rem;
    font-weight: bold;
}

/* Ajusta el ancho de las columnas */
table th:first-child, table td:first-child {
    width: 20%; 
}

table th:nth-child(2), table td:nth-child(2) {
    width: 80%; 
    text-align: left; 
    padding-left: 10px; 
}


table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed; 
}

table th, table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd; 
}

table th {
    background-color: #f4f4f4;
    font-weight: bold;
}



.floating-window table {
    width: 100%;
    table-layout: fixed;
    word-wrap: break-word; 
}

/* Ajuste para los telefonos */
@media screen and (max-width: 768px) {
    .floating-window {
        width: 90%; 
        padding: 10px;
    }

    table th, table td {
        padding: 5px;
        font-size: 0.9rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Css/tables/tabla_consultar.css"],"names":[],"mappings":";AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;;;AAIA;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,8BAA8B;AAC9B;IACI;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":["\r\n.overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.6); \r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 999; \r\n    overflow: hidden; \r\n}\r\n\r\n/* Estilo para la ventana flotante */\r\n.floating-window {\r\n    background: #fff;\r\n    padding: 20px; \r\n    border-radius: 8px;\r\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\r\n    width: 50%; \r\n    max-height: 80vh; \r\n    overflow-y: auto; \r\n    display: flex;\r\n    flex-direction: column; \r\n    z-index: 1000;\r\n}\r\n\r\n/* Encabezado de la tabla */\r\n.floating-window h3 {\r\n    text-align: center;\r\n    margin-bottom: 15px;\r\n    font-size: 1.2rem;\r\n    font-weight: bold;\r\n}\r\n\r\n/* Ajusta el ancho de las columnas */\r\ntable th:first-child, table td:first-child {\r\n    width: 20%; \r\n}\r\n\r\ntable th:nth-child(2), table td:nth-child(2) {\r\n    width: 80%; \r\n    text-align: left; \r\n    padding-left: 10px; \r\n}\r\n\r\n\r\ntable {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    table-layout: fixed; \r\n}\r\n\r\ntable th, table td {\r\n    padding: 10px;\r\n    text-align: left;\r\n    border-bottom: 1px solid #ddd; \r\n}\r\n\r\ntable th {\r\n    background-color: #f4f4f4;\r\n    font-weight: bold;\r\n}\r\n\r\n\r\n\r\n.floating-window table {\r\n    width: 100%;\r\n    table-layout: fixed;\r\n    word-wrap: break-word; \r\n}\r\n\r\n/* Ajuste para los telefonos */\r\n@media screen and (max-width: 768px) {\r\n    .floating-window {\r\n        width: 90%; \r\n        padding: 10px;\r\n    }\r\n\r\n    table th, table td {\r\n        padding: 5px;\r\n        font-size: 0.9rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
